__turbopack_context__.v({
  "curved_corner_bottom_right": "stnrNa_curved_corner_bottom_right",
  "curved_corner_top_right": "stnrNa_curved_corner_top_right",
  "get_help": "stnrNa_get_help",
  "help_button_spacing": "stnrNa_help_button_spacing",
  "help_button_spacing_open": "stnrNa_help_button_spacing_open",
});
